export default __webpack_public_path__ + "static/media/gallery_14.e10b06c9.jpg";